import { inject, injectable } from "inversify";
import { ICriarWebserviceModel } from "../services/types";
import { IResponseWebserviceModel } from "../services/types";
import { EPluggyTypes } from "@/core/@types/types";
import { type WebserviceGateway } from "../services/ports/WebserviceGateway";

export interface IHandleWebservice {
  handleCriarWebservice(
    itemId: string,
    contaId: string,
    onErrorDisplayed: boolean,
    visibility: boolean,
    origem: string
  ): Promise<void>;

  handleEditarWebservice(model: ICriarWebserviceModel): Promise<boolean>;

  handleObterWebservicePluggyPorConta(
    id: string
  ): Promise<IResponseWebserviceModel | void>;

  handleObterWebservicePluggy(
    id: string
  ): Promise<IResponseWebserviceModel | void>;
}

@injectable()
export default class handleCriarWebservice implements IHandleWebservice {
  @inject(EPluggyTypes.CRIAR_WEBSERVICE)
  private webserviceGateway!: WebserviceGateway;

  private createWebserviceModel(
    itemId: string,
    contaId: string,
    visibility: boolean = true
  ): ICriarWebserviceModel {
    // Regra de negócio do front-end legado em Global.js: representar o item
    // Pluggy como Webservice visível ou temporariamente não visível.
    return {
      API: "203",
      ContaBancaria: contaId,
      Inativo: !visibility,
      ApiPluggy: {
        itemId: itemId,
        WebserviceNotVisible: !visibility,
        needConnectWidget: !visibility
      }
    };
  }

  async handleCriarWebservice(
    itemId: string,
    contaId: string,
    onErrorDisplayed: boolean,
    visibility: boolean = true,
    origem: string
  ): Promise<void> {
    const model = this.createWebserviceModel(itemId, contaId, visibility);

    await this.webserviceGateway.criarWebservice(
      model,
      onErrorDisplayed,
      visibility,
      origem
    );
  }

  async handleEditarWebservice(model: ICriarWebserviceModel): Promise<boolean> {
    return await this.webserviceGateway.editarWebservice(model);
  }

  async handleObterWebservicePluggyPorConta(
    id: string
  ): Promise<IResponseWebserviceModel | void> {
    return await this.webserviceGateway.obterWebservicePluggyPorConta(id);
  }

  async handleObterWebservicePluggy(
    id: string
  ): Promise<IResponseWebserviceModel | void> {
    return await this.webserviceGateway.obterWebservicePluggy(id);
  }
}
